import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";

// utils
import { showMessage } from "utils/message.js";

// api
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api.js';


export default function DRECadTim() {
    const { handleSubmit, register, errors, clearErrors, reset } = useForm({ mode: "onBlur" });
    const [showLoading, setShowLoading] = useState(false);
    const [arquivoCadTim, setArquivoCadTim] = React.useState(null);


    //===================================================================================CHANGE ARQUIVO================================================================================================//
    const onChangeCadTim = async (event) => {
        const file = event.target.files[0];
        setArquivoCadTim(file);
        clearErrors("arquivo");
    };
    //=======================================================================================================================================================================================================//

    //===================================================================================SUBMIT ARQUIVOS - API================================================================================================//

    const onSubmit = () => {
        setShowLoading(true)
        dadosimplantacaotim_api.uploadCadTim(arquivoCadTim).then(result => {
            setShowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Arquivos importados com sucesso!", 'success', null);
                reset();
            }
        })
    }
    //=======================================================================================================================================================================================================//

    //===================================================================================Atualização manual - Sincronização GU ================================================================================================//

    const handleAtualizaCadTim = () => {
        setShowLoading(true)
        dadosimplantacaotim_api.sincronizaCadTim().then(result => {
            setShowLoading(false);
            if (result.status !== 200 || result.data == false) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "CadTim atualizado com sucesso!", 'success', null);
                reset();
            }
        })
    }
    //=======================================================================================================================================================================================================//
    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <h5>Atualização Manual - Importar planilha CadTIM</h5>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg="10" md="10" sm="10" className="mt-2">
                            <FormGroup>
                                <label>Planilha de Cadastros *</label>
                                <Input
                                    type="file"
                                    accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsb"
                                    label={"Arquivo *"}
                                    variant="outlined"
                                    name="arquivo"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={onChangeCadTim}
                                    innerRef={register({ required: true })}
                                />
                                {errors.arquivo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="2" md="2" sm="2" className="mt-2">
                            <Button color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                        </Col>
                    </Row>
                </Form>

                <hr size="50" width="100%" align="center" style={{ marginTop: "50px", marginBottom: '30px' }} noshade></hr>
                <h5>Atualização Manual - Sincronização GU</h5>
                <Button color="info" type="submit" onClick={handleAtualizaCadTim}> Atualizar CadTIM</Button>
            </div>

        </>
    );
}
